import React from 'react';
import moment from 'moment';
import classNames from 'classnames';

import { injectIntl } from '../../util/reactIntl';
import { createSlug } from '../../util/urlHelpers';
import { NamedLink } from '..';
import css from './TalentCard.module.css';
import treeImg from '../../../src/assets/images/tree.png';

const Img = ({ src, fallback, alt, className }) => (
    <img
        src={src}
        alt={alt || ''}
        className={className}
        loading="lazy"
        onError={fallback ? e => { e.currentTarget.onerror = null; e.currentTarget.src = fallback; } : undefined}
    />
);

const TalentCard = props => {
    const {
        intl,
        listing,
        className,
        rootClassName,
        listingConfig,
    } = props;

    const combinedIndustries = [
        ...new Set([
            ...(listingConfig?.newCompanyIndustry || []),
            ...(listingConfig?.companyIndustry || []),
        ])
    ];

    const { id, attributes, author } = listing || {};
    const { title, price, publicData } = attributes || {};
    const { uuid } = id || {};

    const {
        skills,
        location,
        addSelfie1,
        experiences,
        uploadVideoInPhotoes,
        roles,
        listingType,
        addSelfie1Fallback
    } = publicData || {};

    const boardMember = (experiences && experiences?.length && Array.isArray(experiences) && experiences[0]?.boardMember) || false;
    const { publicData: APublicData } = (author && author.id && author.attributes.profile) || {};

    const {
        mainProfession,
        availableHoursPerWeek,
        companyImage = '',
        location: userLocation
    } = (APublicData) || {};

    const classes = classNames(rootClassName || css.cardroot, className);
    const { timezone } = (userLocation) || {};

    function getInitials(name) {
        return name?.split(' ').map(word => word?.charAt(0)?.toUpperCase())?.join('');
    }
    const initials = getInitials(title);

    // Get raw image URL
    const rawImgUrl = companyImage
        || uploadVideoInPhotoes?.replace(/\.(mp4|mkv|wmv|m4v|mov|avi|flv|webm|flac|mka|m4a|aac|ogg)$/i, '.png')
        || addSelfie1;

    const imgFallback = addSelfie1Fallback || treeImg;

    // For Cloudinary URLs inject high-quality transformation params
    const imgUrl = rawImgUrl?.includes('res.cloudinary.com')
        ? rawImgUrl.replace('/upload/', '/upload/q_auto:best,f_auto,w_800/')
        : rawImgUrl;

    const yearOfExperience = (experiences && experiences.length && experiences[0].inputValues && experiences[0].inputValues.yearOfExperience && experiences[0].inputValues.yearOfExperience.key)
        ? moment().diff(moment(parseInt(experiences[0].inputValues.yearOfExperience.key), 'YYYY'), 'year')
        : null;

    const wrapperClass = listingType === 'company'
        ? css.wrapperCompany
        : css.wrapper;

    return (
        <NamedLink
            name="AlgoliaSearchPage"
            className={classes}
            to={{
                search: uuid
                    ? '&query=' + uuid
                    : '',
            }}
        >
            <div className={css.root}>
                <div className={wrapperClass}>
                    <div className={css.flexRow}>
                        <div className={css.imgWrap}>
                            <Img
                                src={imgUrl || imgFallback}
                                fallback={imgFallback}
                                alt={'pro'}
                                className={css.img}
                            />
                        </div>

                        <div className={css.cardRightContent}>
                            {initials && listingType !== 'company' ? (
                                <div className={css.titleSpacer} />
                            ) : (
                                <h4>{title?.length > 36 ? title?.slice(0, 20) + "..." : title}</h4>
                            )}
                            {experiences && experiences.length
                                ? <h5>
                                    <strong>{experiences[0].label}</strong>
                                </h5>
                                : null}
                            <ul>
                                {yearOfExperience
                                    ? <li>{yearOfExperience}{yearOfExperience > 1 ? ' years' : ' year'} experience </li>
                                    : null}
                                {availableHoursPerWeek
                                    ? <li>
                                        {availableHoursPerWeek}h per {boardMember ? 'month' : 'week'}  available
                                    </li>
                                    : null}
                                {timezone
                                    ? <li>
                                        {moment().tz(timezone).format('z')} Time zone
                                    </li>
                                    : null}
                                {(roles && roles.length && roles[0] && roles[0]?.perHourRate && roles[0]?.perHourRate?.label)
                                    ? <li>
                                        {roles[0].availableHoursPerWeek.label} {roles[0].boardMember ? 'Monthly' : 'Weekly'}
                                    </li>
                                    : null}
                                {roles && roles.length ? <li>Start {roles[0].startDate ? new Date(roles[0].startDate?.date).toLocaleDateString() : roles[0].start}</li> : null}
                            </ul>
                        </div>
                    </div>
                </div>

                <p className={css.cardType}>
                    {combinedIndustries && combinedIndustries.length
                        ? combinedIndustries.find(ind => ind?.option === mainProfession)?.label
                        : null}
                </p>
            </div>
        </NamedLink>
    );
};

export default injectIntl(TalentCard);

